<div class="otp-dialog-container">
  <h1 mat-dialog-title class="otp-title">
    <mat-icon class="otp-icon">security</mat-icon>
    Enter Verification Code
  </h1>
  <mat-dialog-content class="otp-content">
    <p class="otp-description">
      Please enter the 6-digit code sent to your email address
    </p>
    <form (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="otp-input-container">
        @for (digit of otpDigits; track digit; let i = $index) {
          <div class="otp-input-wrapper">
            <input
              id="otp-input-{{i}}"
              maxlength="1"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="one-time-code"
              [(ngModel)]="otpDigits[i]"
              name="otp-{{i}}"
              (keydown)="onKeyDown($event, i)"
              (focus)="onFocus(i)"
              (paste)="onPaste($event, i)"
              class="otp-input"
              [class.filled]="otpDigits[i] !== ''"
              [class.focused]="currentIndex === i"
              />
          </div>
        }
      </div>
      <div class="otp-actions">
        <button mat-button color="primary" type="button" (click)="onCancel()" class="cancel-btn">
          Cancel
        </button>
        <button mat-raised-button color="primary" id="otp-verify-btn" type="submit" [disabled]="!isOtpComplete" class="submit-btn">
          Verify
        </button>
      </div>
    </form>
  </mat-dialog-content>
</div>